import React, { FC, useState, useEffect } from "react";
import { fetchDocumentDeleteRequest } from "../../../redux/slices/DeleteRequestDocumentsSlice";
import { patchDeleteRequestDocument } from "../../../redux/slices/UpdateDeleteRequestDocumentSlice";
import { filterDocuments } from "../../../redux/slices/DocumentsSlice";
import { fetchUser } from "../../../redux/slices/UsersSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
import { IDocuments } from "../../../types/Document";
import { IResult } from "../../../types/Users";
import "./AdminDocumentDeletedRequest";
import Swal from "sweetalert2";
import { isHttpCodeSuccess, handleSwalMessage } from "../../../Helpers/Http.commons";
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';

interface DeleteRequestDocument {
  id: string;
  documentId: string;
  requestedUserId: string;
  status: string;
}

interface RequestResponse {
  statusCode: number;
  response: Object;
  error: any;
}

const AdminDocumentDeletedRequest = () => {
  const { id, repositoryname } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const tokenID = sessionStorage.getItem("idToken");
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const requestId = String(id);
  const repositoryNamee = String(repositoryname);
  const { instance } = useMsal();
  const result: DeleteRequestDocument = useAppSelector(
    (state) => state.DeleteRequestDocumentsSlice.result
  );

  const user: IResult = useAppSelector((state) => state.UsersSlice.result);

  console.log('result', result);

  useEffect(() => {
    setLoading(true);
    loadContent();
    setLoading(false);
  }, [requestId]);
  
  const loadContent = async () => {
    await refreshToken2(instance);
    console.log("refreshToken2 finished");
    if(requestId){
      await dispatch(
        fetchDocumentDeleteRequest({
          repositoryName: repositoryNamee,
          id: requestId,
        })
      );
    }
    console.log("fetch fetchDocumentDeleteRequest finished");
  };

  useEffect(() => {
    const { requestedUserId, documentId } = result;

    if (requestedUserId)
      dispatch(fetchUser({ requestedUserId: requestedUserId }));

    if (documentId) dispatch(filterDocuments(documentId));
  }, [result]);

  const handleDocumentRequest = (requestId: string, status: string) => {
    dispatch(
      patchDeleteRequestDocument({
        id: requestId,
        data: { status },
        repositoryName: repositoryNamee,
      })
    ).then((responseData) => {
      if (patchDeleteRequestDocument.fulfilled.match(responseData)) {
        const { statusCode, response, error } = responseData.payload;
        const swalData: any = handleSwalMessage(responseData.payload, status);
        Swal.fire(swalData);

        if (isHttpCodeSuccess(statusCode)) {
          console.log('============ REDIRECT LOG: [AdminDocumentDeletedRequest] - Navigate to /my-repositories');
          navigate("/my-repositories");
         
        }
      } else if (patchDeleteRequestDocument.rejected.match(responseData)) {
        Swal.fire({
          icon: "error",
          title: "Error de Conexión",
          text: "Revise su conexión a internet y vuelva a intentar",
        });
      }

      setLoading(false);
    });
  };

  const documents: IDocuments[] = useAppSelector(
    (state) => state.DocumentsSlice.result
  );

  const documentData = documents[0] ?? {
    id: "",
    path: "",
    fileName: "",
    description: "",
  };

  const userData = user ?? { userId: "", name: "", email: "", userType: "" };

  return loading ? (
    <Spinner />
  ) : (
    <div className="cardcontainer-deleted">
      <div className="pds-card pds-productCard productcard-deleted">
        <div
          className="pds-card-section pds-card-bg-primary-blue-2"
          tabIndex={0}
        >
          <h3 className="pds-card-title pds-typography-truncate">
            &nbsp;Solicitud de Eliminacion de Documentos
          </h3>
          <p className="pds-typography-body-14">
            (*) Para continuar con la solicitud favor seleccionar aprobar o
            rechazar
          </p>
        </div>
        <div className="pds-card-section">
          <dl className="pds-gridTable" tabIndex={0}>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6  pds-typography-eyebrow-2">
                Usuario Solicitante
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{userData.name}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2 ">
                Nombre del Documento
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2 ">
                <span className="">{documentData.fileName}</span>
                <br />
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                Descripcion
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{documentData.description}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                Directorio
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{documentData.path}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="pds-typography-bold">Estado</span>
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{result.status}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 "></dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                {result.status === "rejected" ||
                result.status === "finished" ? (
                  <Link to="/my-repositories">
                    <button className="pds-button pds-button-primary">
                      <i data-feather="corner-up-left" aria-hidden="true"></i>{" "}
                      Volver
                    </button>
                  </Link>
                ) : (
                  <>
                    <button
                      className="pds-button pds-button-primary button-approve"
                      disabled={
                        result.status === "rejected" ||
                        result.status === "finished" ||
                        loading
                      }
                      onClick={async () => {
                        setButtonLoading(true);
                        handleDocumentRequest(requestId, "finished");
                        setButtonLoading(false);
                      }}
                    >
                      <i data-feather="check-circle" aria-hidden="true"></i>{" "}
                      {buttonLoading ? <Spinner /> : "Aprobar"}
                    </button>
                    &nbsp;
                    <button
                      className="pds-button pds-button-primary button-rejected"
                      disabled={
                        result.status === "rejected" ||
                        result.status === "finished" ||
                        loading
                      }
                      onClick={async () => {
                        setButtonLoading(true);
                        handleDocumentRequest(requestId, "rejected");
                        setButtonLoading(false);
                      }}
                    >
                      <i data-feather="trash-2" aria-hidden="true"></i>{" "}
                      {buttonLoading ? <Spinner /> : "Rechazar"}
                    </button>
                  </>
                )}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default AdminDocumentDeletedRequest;
